import { Divider, Grid, Typography } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import type { AmenitiesGroup, Amenity } from "libs/codegen/property-onboarding";
import { Fragment, type FunctionComponent } from "react";
import { AmenityCard } from "./AmenityCard";

export interface AmenityGroupProps extends AmenitiesGroup {
    activeIds: number[];
    onClick?: (amenity: Amenity) => void;
    divider?: boolean;
}

export const AmenityGroup: FunctionComponent<AmenityGroupProps> = ({
    title,
    description,
    amenities,
    divider,
    activeIds,
    onClick,
}) => {
    return (
        <Fragment>
            {divider && <Divider />}
            <VStack gap="16">
                <VStack gap="8">
                    <Typography variant="heading-default">{title}</Typography>
                    <Typography variant="body-s" textColor="base.subtle">
                        {description}
                    </Typography>
                </VStack>
                <Grid spacing="16">
                    {amenities.map((amenity) => (
                        <AmenityCard
                            selected={activeIds.includes(amenity.id)}
                            onClick={() => onClick(amenity)}
                            key={`amenity-${amenity.id}`}
                            {...amenity}
                        />
                    ))}
                </Grid>
            </VStack>
        </Fragment>
    );
};
